import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const stripeIntentDto = z.object({
  id: z.string(),
  client_secret: z.string(),
});

export class StripeIntentDto extends createZodDto(stripeIntentDto) {}
